import $ from "jquery";
import 'tablesorter';
import 'tablesorter/dist/js/jquery.tablesorter'
import 'tablesorter/dist/js/jquery.tablesorter.combined'
import 'tablesorter/dist/js/jquery.tablesorter.widgets'
import 'tablesorter/dist/js/extras/jquery.tablesorter.pager.min'

const historyTableInitialize = (elementTableId) => {
$(elementTableId)
    .tablesorter({
        theme: "bootstrap",
        dateFormat: "MM/DD/YYYY",
        widthFixed: true,
        fixColumnWidth: true,
        showProcessing: true,
        widgets: ["columns"],

        widgetOptions: {
            columns: ['primary', 'secondary', 'tertiary'],

            filter_cssFilter: [
                'd-none',
                'd-none',
                'd-none',
                'd-none',
                'd-none',
            ],
            filter_childRows: false,

            filter_childByColumn: false,
        }
    })

    .tablesorterPager({
        container: $(".ts-pager"),
        cssGoto: ".pagenum",
        removeRows: false,
        output: '{startRow} - {endRow} / {filteredRows} ({totalRows})'
    });
}

const authHistoryTable = () => {
    historyTableInitialize('#auth-history-table');
}

const authHistoryTableMob = () => {
    historyTableInitialize('#auth-history-table-sm');
}

const lockAccount = () => {
    location.href = '/suspicious-login';
}

const showConfirmLockAccount = () => {
    $('#confirmLockAccount').modal('show')
}

$(document).ready(() => {
    if (location.pathname === '/authorization-history') {
        authHistoryTable()
        authHistoryTableMob()
    }
})

window.showConfirmLockAccount = showConfirmLockAccount;
window.lockAccount = lockAccount;

